module.exports = __webpack_public_path__ + "static/media/crazy_ski_saga.350d47e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/crazy_ski_saga.png
// module id = 300
// module chunks = 0